import Blue from "~/core";

new Blue({
  name: "salesforce chat position",
  selector: "body",
  setup(body) {
    const style = document.createElement("STYLE");
    const main = document.querySelector("main.content, main.contentMain");
    const newspaper = document.querySelector(".newspaper");
    const setOffsetStyle = () => {
      let buttonRight = window.getComputedStyle(main).marginRight;
      let modalRight = buttonRight;
      let bottom = 0;

      const makeStyle = () => {
        return `
        body .embeddedServiceSidebar.layout-docked .dockableContainer {
          right: ${modalRight} !important;
        }
        body .embeddedServiceHelpButton .helpButton {
          right: ${buttonRight} !important;
          bottom: ${bottom} !important;
        }
        body .embeddedServiceHelpButton .helpButton .uiButton {
          background: #385e9d !important;
        }`;
      };

      if (parseInt(buttonRight) < 24 || newspaper) {
        buttonRight = "24px";
        modalRight = "12px";
      }

      if (!window.matchMedia("(min-width: 48rem)").matches) {
        bottom = "16px";
      }

      style.textContent = makeStyle();
    };

    setOffsetStyle();

    document.head.insertAdjacentElement("beforeend", style);
    window.addEventListener("resize", setOffsetStyle);
    window.addEventListener("orientationchange", setOffsetStyle);
  }
});

new Blue({
  name: "salesforce chat footer",
  selector: "body",
  setup(body) {
    var template = document.querySelector(".BM_SF_Chat_Template");
    var targetNode = document.body;
    var config = {
      attributes: false,
      childList: true,
      subtree: true
    };

    var callback = function callback(mutationsList, observer) {
      for (var i = 0; i < mutationsList.length; i++) {
        var mutation = mutationsList[i];

        if (mutation.type === "childList") {
          var container = document.querySelector(
            ".embeddedServiceLiveAgentStatePrechatDefaultUI, .embeddedServiceLiveAgentStateOfflineSupportDefaultUI"
          );
          var form;

          if (container) {
            form = container.querySelector(
              ".formContent.embeddedServiceSidebarForm"
            );
            if (!form.querySelector(".BM_SF_Chat_Footer")) {
              var content = template.content.cloneNode(true);
              form.appendChild(content);
            }
          }
        }
      }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
